import { useState } from "react";
import { hotComments, liveThread } from "@/mocks/homeData";

export default function CommentBuzz() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const toggleLike = (name: string) => {
    setLiked((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  return (
    <section id="buzz" className="border-t border-background-200 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              热评现场
              <span className="flex h-6 items-center rounded-full bg-primary-100 px-2 text-[11px] font-medium text-primary-700">
                高能
              </span>
            </h2>
            <p className="mt-2 text-sm text-foreground-500">吃瓜群众的最新留言与讨论焦点，气氛拉满。</p>
          </div>
          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-chat-smile-2-line" />
            今日新增 1.2 万条讨论
          </span>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-8">
          <div className="flex flex-col gap-4 lg:col-span-8">
            {hotComments.map((comment) => {
              const isLiked = !!liked[comment.name];
              return (
                <article
                  key={comment.name}
                  className="rounded-lg border border-background-200 bg-background-100/50 p-4 md:p-5"
                >
                  <div className="flex items-center gap-3">
                    <div className="h-10 w-10 shrink-0 overflow-hidden rounded-full border border-background-300">
                      <img
                        src={comment.avatar}
                        alt={`${comment.name} 的头像`}
                        title={`${comment.name} - 黑料社网热评`}
                        className="h-full w-full object-top"
                      />
                    </div>
                    <div className="min-w-0">
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-semibold text-foreground-900">{comment.name}</span>
                        <span className="rounded-sm bg-accent-100 px-1.5 py-0.5 text-[10px] font-medium text-accent-800">
                          {comment.topic}
                        </span>
                      </div>
                      <span className="text-[11px] text-foreground-500">{comment.time}</span>
                    </div>
                  </div>

                  <p className="mt-3 text-sm leading-relaxed text-foreground-800">{comment.text}</p>

                  <div className="mt-4 flex items-center gap-5 text-xs text-foreground-500">
                    <button
                      type="button"
                      onClick={() => toggleLike(comment.name)}
                      className={`flex cursor-pointer items-center gap-1.5 transition-colors ${
                        isLiked ? "text-primary-600" : "hover:text-foreground-800"
                      }`}
                    >
                      <i className={isLiked ? "ri-heart-3-fill" : "ri-heart-3-line"} />
                      {comment.likes}
                    </button>
                    <button
                      type="button"
                      className="flex cursor-pointer items-center gap-1.5 transition-colors hover:text-foreground-800"
                    >
                      <i className="ri-chat-3-line" />
                      回复
                    </button>
                    <button
                      type="button"
                      className="ml-auto flex cursor-pointer items-center gap-1.5 transition-colors hover:text-foreground-800"
                    >
                      <i className="ri-share-forward-line" />
                      转发
                    </button>
                  </div>
                </article>
              );
            })}

            <div className="flex items-center gap-3 rounded-lg border border-dashed border-background-300 bg-background-100/40 p-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-background-200 text-foreground-500">
                <i className="ri-user-line" />
              </div>
              <div className="flex-1 text-sm text-foreground-500">说点什么吧，理性吃瓜，不站队。</div>
              <button
                type="button"
                className="cursor-pointer whitespace-nowrap rounded-full bg-foreground-950 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
              >
                发布
              </button>
            </div>
          </div>

          <div className="lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-secondary-50/60 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-discuss-line text-secondary-600" />
                </span>
                大家正在讨论
              </h3>
              <div className="mt-4 flex flex-col divide-y divide-secondary-100">
                {liveThread.map((thread, index) => (
                  <a
                    key={thread.title}
                    href="#buzz"
                    className="group flex items-start gap-3 py-3 transition-colors"
                  >
                    <span className="mt-0.5 w-4 shrink-0 font-heading text-sm font-bold text-secondary-400">
                      {index + 1}
                    </span>
                    <div className="min-w-0 flex-1">
                      <h4 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-secondary-700">
                        {thread.title}
                      </h4>
                      <span className="mt-1 flex items-center gap-2 text-[11px] text-foreground-500">
                        <span className="flex items-center gap-1">
                          <i className="ri-chat-3-line" />
                          {thread.replies} 回复
                        </span>
                        <span
                          className={`rounded-sm px-1.5 py-0.5 text-[10px] font-medium ${
                            thread.heat === "爆"
                              ? "bg-primary-100 text-primary-700"
                              : thread.heat === "热"
                                ? "bg-accent-100 text-accent-800"
                                : "bg-secondary-100 text-secondary-800"
                          }`}
                        >
                          {thread.heat}
                        </span>
                      </span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}